import { ReactNode, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import GenericErrorMessageModal from "@/components/forms/errorHandling/genericErrorMessageModal";
import { HelpLinksByField } from "@/components/forms/errorHandling/errorMessageLines";

interface UseErrorModalResult {
  error: any;
  handleError: (error: any) => void;
  clearError: () => void;
  errorModal: ReactNode;
}

export function useErrorModal(
  title?: string,
  options?: {
    onClose?: () => void;
    confirmButtonText?: string;
    helpLinksByField?: HelpLinksByField;
  },
): UseErrorModalResult {
  const { t } = useTranslation();
  const [error, setError] = useState<any>();
  const { onClose, confirmButtonText, helpLinksByField } = options ?? {};

  const handleError = useCallback((newError: any) => {
    setError(newError);
  }, []);

  const clearError = useCallback(() => {
    setError("");
    onClose?.();
  }, [onClose]);

  const errorModal: ReactNode =
    error && error !== "" ? (
      <GenericErrorMessageModal
        title={title ?? t("error_occurred")}
        error={error}
        confirmButtonText={confirmButtonText}
        helpLinksByField={helpLinksByField}
        onClosehandler={clearError}
      />
    ) : null;

  return { error, handleError, clearError, errorModal };
}
